// Gamble Toggle Button

gambleToggleButton = {};

gambleToggleButton.create = function() {
	var button = new PIXI.Container();

	InputHelpers.addGenerics(button);
	button._flags.showDisclaimer = true;

	button.canEnable = function() {
		return true; 
	};

	button.showButton = function() {
		if (this.canShow()) {
			if (button._flags.showDisclaimer) {
				///this.button.buttonDisabled.tint = 0x999999;
				//this.button.buttonEnabled.tint = 0x999999;

				this.button.buttonDisabled.visible = true;
				this.button.buttonEnabled.visible = false;
			} else {
				//this.button.buttonDisabled.tint = 0xFFFFFF;
				//this.button.buttonEnabled.tint = 0xFFFFFF;

				this.button.buttonDisabled.visible = false;
				this.button.buttonEnabled.visible = true;
			}

			this.button.visible = true;
		} else {
			this.hideButton();
		}
	};

	button.onPressedCallback = function() {		
		button._flags.showDisclaimer = !button._flags.showDisclaimer;

		soundManager.play("buttonPressV1");
	};
	
	button.getShowDisclaimer = function() {
		return button._flags.showDisclaimer;
	};

	// button.onCurrentMuteState = function(state) {
	// 	this._flags.muted = state.muted;
	// };
	
	//messageBus.subscribe("audio:currentMuteState", button.onCurrentMuteState.bind(button));

	return button;
};

gambleToggleButton.initialise = function(json, object) {};
gambleToggleButton.getFilesRequired = function() {
	return [];
};

resourceManager.registerObjectType("gambleToggleButton", gambleToggleButton.create, gambleToggleButton.initialise, gambleToggleButton.getFilesRequired);